module.exports = __webpack_public_path__ + "assets/img/form-verification-icon1.c0ee6fdb.png";